<template>
  <div>
    <el-form
      :model="searchForm"
      :inline="true"
    >
      <el-form-item label="部门" prop="departId">
        <el-input v-model="searchForm.department" size="small" clearable/>
      </el-form-item>
      <el-form-item>
        <template>
          <el-button type="primary" size="mini" icon="el-icon-search" @click="searchList()">查询</el-button>
        </template>
      </el-form-item>
      <el-form-item style="margin-left:15px; font-weight:bold">
        <span>秘书是您咨询的窗口，您有任何使用上的问题我们都会耐心为您解答(●'◡'●)！请钉钉联系我们</span>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      :header-cell-style="{background:'#409eff',padding:'8px 0',color:'#fff'}"
      border>
      <el-table-column label="管理部门" prop="department" align="center"/>
      <el-table-column label="第一部门秘书" prop="one_name" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.one_name }} ({{ scope.row.one_workcode }})</span>
        </template>
      </el-table-column>
      <el-table-column label="第二部门秘书" prop="two_name" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.two_name }} ({{ scope.row.two_workcode }})</span>
        </template>
      </el-table-column>
      <el-table-column label="部门负责人" prop="leader" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.leader && scope.row.leader !== '' ? scope.row.leader+'('+scope.row.leader_workcode+')' : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="部门BP" prop="sector_bp" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.sector_bp && scope.row.sector_bp !== '' ? scope.row.sector_bp+'('+scope.row.sector_bp_workcode +')' : '' }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 10px; text-align: center">
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"/>
    </div>
  </div>
</template>
<script>
import { getAllSecretary } from '../../api/secretary'
export default {
  data() {
    return {
      searchForm: {
        department: null
      },
      tableData: [

      ],
      page: 1,
      pageSize: 10,
      total: 0
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    searchList() {
      this.page = 1
      this.getList()
    },
    // 查询秘书配置列表
    getList() {
      const params = {
        department: this.searchForm.department,
        is_available: 1,
        page: this.page,
        page_size: this.pageSize
      }
      getAllSecretary(params).then(res => {
        console.log(res)
        if (res.code === 'success') {
          this.total = res.data.pagination.total
          this.tableData = res.data.secretary
        } else {
          this.total = 0
          this.tableData = []
        }
      }).catch(err => {
        console.log(err)
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getList()
    }
  }
}
</script>
<style lang="sass">

</style>
